import { render, staticRenderFns } from "./OpsColumn.vue?vue&type=template&id=4fab489a&scoped=true"
import script from "./OpsColumn.vue?vue&type=script&lang=js"
export * from "./OpsColumn.vue?vue&type=script&lang=js"
import style0 from "./OpsColumn.vue?vue&type=style&index=0&id=4fab489a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fab489a",
  null
  
)

export default component.exports